var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39 40",
    style: {
      enableBackground: "new 0 0 39 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#6A4E37;stroke-width:1.8343;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,15.3l7.2-7.2 M19.6,24.1L30,13.7 M19.6,32.1l12-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,36.2c7.1,0,12.8-5.9,12.8-13.1c0-7.2-4.1-15.5-10.5-18.5c-0.7-0.3-1.5-0.5-2.3-0.5 M19.6,36.2 c-7.1,0-12.8-5.9-12.8-13.1c0-7.2,4.1-15.5,10.5-18.5c0.7-0.3,1.5-0.5,2.3-0.5 M19.6,36.2V4.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf2);
export default __webpack_public_path__ + "static/media/leaf-2.19b24cb4705a2a1fff4215782e107621.svg";
export { ForwardRef as ReactComponent };